import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticEvents, FeatureFlag } from '@app/enums';
import { DataField } from '@app/models/settings/data-field.model';
import { AssignedEmployeesAndFieldValuesTable } from '@app/modules/settings/services/tables/assigned-employees-and-field-values-table/assigned-employees-and-field-values.table';
import { AnalyticService, AuthService, NotifyService } from '@app/services';
import { FeatureService } from '@app/services/feature.service';
import { RoleNameDisplayOptions } from '@app/types/translatables/role-display.options';

@Component({
    templateUrl: './fields-show.template.html',
    styleUrls: ['./fields-show.style.scss'],
    providers: [{ provide: 'pageSize', useValue: 5 }],
})
export class FieldsShowView implements OnInit {
    isLoading = false;
    field: DataField;
    assignedEmployeesAndFieldValuesTable: AssignedEmployeesAndFieldValuesTable;
    assignedEmployeesAndFieldValuesTablePageSize = 5;
    isDeleteModalOpen = false;
    customFieldsOnDocuments = false;
    roleNameDisplay = RoleNameDisplayOptions;

    constructor(
        public auth: AuthService,
        protected router: Router,
        protected route: ActivatedRoute,
        private notify: NotifyService,
        private featureService: FeatureService,
        private analyticsService: AnalyticService
    ) {
        this.field = this.route.snapshot.data.models.get('field');

        if (this.field) {
            this.assignedEmployeesAndFieldValuesTable = new AssignedEmployeesAndFieldValuesTable(
                this.auth,
                this.field,
                this.assignedEmployeesAndFieldValuesTablePageSize
            );
        }
    }

    async ngOnInit(): Promise<void> {
        this.customFieldsOnDocuments = await this.featureService.has(FeatureFlag.customFieldsOnDocuments);
    }

    onEditFieldInformation(): void {
        this.router.navigate(['/settings', 'custom-fields', 'fields', this.field.id, 'edit']);
    }

    onDelete(): void {
        this.field
            .delete()
            .then(() => {
                this.analyticsService.trackEvent(AnalyticEvents.SettingsModuleDeleteCustomField);
                this.notify.success('settings.custom-fields.customFieldDeletedMessage');
                this.isDeleteModalOpen = false;
                this.router.navigate(['../'], { relativeTo: this.route });
            })
            .catch((err) => {
                this.notify.error(err.message);
            });
    }

    onCancel(): void {
        this.field.revert();
    }

    onAddOrRemoveEmployees(): void {
        this.router.navigate(['/settings', 'custom-fields', 'fields', this.field.id, 'assign-employees']);
    }
}
